/**
 * UN-DOLLAR RENTFLOW — FIREBASE CONFIGURATION (Vite)
 * 
 * Firebase client SDK initialization for Vite
 */

import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Firebase configuration from environment variables (Vite uses import.meta.env)
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Validate required configuration
if (!firebaseConfig.projectId) {
  throw new Error(
    'Firebase configuration is missing. Please ensure VITE_FIREBASE_* environment variables are set in .env file.'
  );
}

// Log current environment for debugging (in development only)
if (import.meta.env.DEV) {
  console.log('🔥 Firebase initialized for project:', firebaseConfig.projectId);
}

// Initialize Firebase (avoid duplicate initialization)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Initialize Analytics (only in browser and if supported)
export const analytics = isSupported().then(yes => yes ? getAnalytics(app) : null);

// Export app instance for advanced use cases
export { app };
